import { React } from "react";
import Header from '../../Header'

// MUI Imports
import Box from '@mui/material/Box';

function GAINTemplate({children, schema, project}) {
    return (
    <>  
        {
            project != null
            &&
            Object.keys(project).length > 0  
            && 
            schema != null
            &&
            Object.keys(schema).length > 0 ?
            <>
                <Header project={project} schema={schema}/>
                <Box className={"screening_tool_container"}>
                    {project.entries !== undefined
                    ?
                    children
                    :
                    ""
                    }  
                    {/* FOOTER AREA */}
                    {schema
                        ?
                            <div className="footer">
                                <p dangerouslySetInnerHTML={{__html:`<i>${schema.screenContent.footer.disclaimer}</i>`}}></p>
                            </div>
                        :
                            ""
                    }
                </Box>
                
            </>
            :
            <h1>Loading</h1>
        }

    </>
    );
}

export default GAINTemplate